export const JoinPath = (...parts: string[]): string => parts.filter(part => part !== "").join("/")
